import { Badge, Box, Button, Card, Center, Group, Loader, Stack, Text, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useState } from 'react';

import { useBatchRequests } from '@admin/hooks';

interface BatchSearchCardProps {
  onBatchSelected: (batchId: string) => void;
}

export const BatchSearchCard = ({ onBatchSelected }: BatchSearchCardProps) => {
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const { data: batchData, isLoading: isLoadingBatch } = useBatchRequests(searchQuery, searchQuery.length > 0);

  const handleSearch = () => {
    setSearchQuery(searchInput);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleBatchSelected = () => {
    if (batchData?.batch) {
      onBatchSelected(batchData.batch._id);
    }
  };

  return (
    <Box mt="md">
      <Text size="sm" fw={500} mb="sm">
        Search for Batch
      </Text>
      <Group>
        <TextInput
          placeholder="Search by batch ID, name, or counter..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.currentTarget.value)}
          onKeyDown={handleKeyDown}
          style={{ flex: 1 }}
          leftSection={<IconSearch size={16} />}
        />
        <Button onClick={handleSearch} loading={isLoadingBatch}>
          Search
        </Button>
      </Group>

      {isLoadingBatch && (
        <Center mt="md">
          <Loader size="sm" />
        </Center>
      )}

      {!isLoadingBatch && searchQuery && !batchData && (
        <Center mt="md">
          <Text size="sm" c="dimmed">
            Batch not found
          </Text>
        </Center>
      )}

      {!isLoadingBatch && batchData && (
        <Card shadow="sm" padding="md" radius="md" withBorder mt="md">
          <Stack gap="xs">
            <Group justify="space-between">
              <Text size="sm" fw={600}>
                Batch Found
              </Text>
              <Badge color="green" variant="light">
                Ready
              </Badge>
            </Group>
            <Group gap="md">
              <Text size="sm">
                <strong>Name:</strong> {batchData.batch.name}
              </Text>
              <Text size="sm">
                <strong>Counter:</strong> {batchData.batch.counter}
              </Text>
            </Group>
            <Button onClick={handleBatchSelected} fullWidth mt="xs">
              Continue with this Batch
            </Button>
          </Stack>
        </Card>
      )}
    </Box>
  );
};
